import focus from '@alpinejs/focus';
// import Alpine from 'alpinejs';
import Alpine from 'alpinejs/dist/module.cjs';
import mask from 'jquery-mask-plugin';
import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import Navbar from './modules/Navbar.js';
import RateCardTilt from './modules/RateCardTilt.js';
import BlockFaq from './blocks/block_faq.js';

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
  Navigation();
  MobileNavigation();
  Navbar();
  RateCardTilt();
});
